import React from 'react';

import ProductPromosOrDTCC from '../../../../components/product-promos-or-dtcc/product-promos-or-dtcc';

import {
  useModal,
  useMyAccount,
  useProductEntryDataLayerValues
} from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';
import { setPlpScrollToHash } from '../../../../shared/utils/back-to-results/back-to-results';
import {
  getCombinedMapPrice,
  getMapProductInstantSavingsInfo,
  getNormalizedProductType,
  getPriceInfo,
  getProductPromotions,
  getProductSetPrice,
  isCanonicalProduct
} from '../../../../shared/utils/product/product';
import { isArrayWithLength } from '../../../../shared/utils/validators/validators';

import { ProductData } from '../../../../shared/types/graphql-types';
import { BundleData } from '../../../../shared/types/product';

import './product-list-card-promos.scss';

interface ProductListCardPromosProps {
  product?: ProductData | BundleData;
  productSet?: Array<ProductData>;
  productSetQuantity?: Array<number>;
  quantity?: number;
  rearQuantity?: number;
}

function ProductListCardPromos(props: ProductListCardPromosProps) {
  const {
    product: item,
    productSet,
    productSetQuantity,
    quantity: itemQuantity = 1,
    rearQuantity: rearItemQuantity = itemQuantity
  } = props;
  let product, rearProduct, quantity, rearQuantity;
  const { getProductEntryDataLayerValues } = useProductEntryDataLayerValues();
  const { isLoggedIn } = useMyAccount();
  const { closeModal } = useModal();

  if (!item && !productSet) return null;

  if (item && 'product1' in item && 'product2' in item) {
    product = item.product1;
    quantity = itemQuantity * 4;
    rearProduct = item.product2;
    rearQuantity = rearItemQuantity * 4;
  } else {
    product = item;
    quantity = itemQuantity;
    rearProduct = product?.rearProduct;
    rearQuantity = rearItemQuantity;
  }

  const { addToCartDisabled } = product || productSet?.[0] || {};

  const productPromotions = getProductPromotions(
    item || productSet?.[0],
    item && 'product1' in item
  );
  const { mapPrice, price } = getPriceInfo(product);
  const { mapPrice: rearMapPrice, price: rearPrice } =
    getPriceInfo(rearProduct);
  const productSetPrice = getProductSetPrice(productSet, productSetQuantity);
  const hasPromotions = isArrayWithLength(productPromotions);
  const { instantMapSavingsPerProduct, totalMapSavings } =
    getMapProductInstantSavingsInfo(product, isLoggedIn, quantity);

  const combinedMapPrice = getCombinedMapPrice({
    mapPrice,
    price,
    productSetPrice,
    quantity,
    rearMapPrice,
    rearPrice,
    rearQuantity
  });

  const productType = getNormalizedProductType(product);

  return (
    <div styleName="container">
      <ProductPromosOrDTCC
        brand={product?.brand}
        combinedMapPrice={combinedMapPrice}
        hasPromotions={hasPromotions}
        instantMapSavingsPerProduct={instantMapSavingsPerProduct}
        onSignIn={() => {
          setPlpScrollToHash(product?.code);
          closeModal();
        }}
        productType={productType}
        promoLinkOnClick={() =>
          trackAction(
            'product_savings_available_click',
            getProductEntryDataLayerValues(product || productSet?.[0])
          )
        }
        promotionData={productPromotions}
        showDtccBanner={
          !isCanonicalProduct(product) && !addToCartDisabled && !hasPromotions
        }
        showLongDescription
        totalMapSavings={totalMapSavings}
      />
    </div>
  );
}

export default ProductListCardPromos;
